import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EnrollmentNew } from 'src/app/modules/enrollments/models/enrollment-new.model';
import { AlertMessage } from 'src/app/template/models/alert-message.model';

@Component({
    selector: 'app-enrollment-edit-step-privacy-policy',
    templateUrl: './enrollment-edit-step-privacy-policy.component.html',
    styleUrls: ['./enrollment-edit-step-privacy-policy.component.scss']
})
export class EnrollmentEditStepPrivacyPolicyComponent implements OnInit {

    @Input() enrollment: EnrollmentNew;

    @Output() enrollmentChange = new EventEmitter<EnrollmentNew>();
    @Output() isCompleteStep= new EventEmitter<boolean>();

    public labels: any = {

        privacyPolicyLabel : 'Políticas de privacidad',
        loadingErrorMessage: 'Se ha producido un error al cargar la página.'

    }

    public loadingMessage: AlertMessage = new AlertMessage();
    public privacyPolicy: string;
    public campusName   : string;

    ngOnInit (): void {

        this.privacyPolicy = this.enrollment.edition.resources.find((r: any) => r.resourceId === 'enrollment-lopd').value;
        this.campusName    = this.enrollment.edition.campusName;

        if (!this.privacyPolicy || !this.campusName) {
            this.loadingMessage.showDangerAlert(this.labels.loadingErrorMessage);
        }

        this.onEnrollmentChange();

    }

    public onCheckboxChange() {

        this.onEnrollmentChange();

    }

    public isFormValid() {

        let isValidConditions    = this.enrollment.conditionsChecked;
        let isValidAuthorization = this.enrollment.authorizationChecked;

        return isValidConditions && isValidAuthorization;

    }

    public onEnrollmentChange() {

        this.isCompleteStep.emit(this.isFormValid());
        this.enrollmentChange.emit(this.enrollment);

    }

}
